import React from "react";

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg my-10">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-6 mt-10">Terms and Conditions</h1>
      <p className="text-sm text-gray-600 text-center">Effective Date: April 1, 2025</p>
      <p className="mb-4 text-gray-600">
        Welcome to The Best Cab by Bharat Tours & Travels! By accessing and using our website and services, you agree to comply with the following terms and conditions. Please read them carefully.
      </p>
      
      <h2 className="text-xl font-semibold mt-4 text-gray-600">1. Booking and Payments</h2>
      <ul className="list-disc list-inside mb-4 text-gray-600">
        <li>All bookings must be made through our website, customer support, or authorized partners.</li>
        <li>Full or partial payment may be required at the time of booking.</li>
        <li>Payments are accepted via credit/debit cards, UPI, net banking, or other approved methods.</li>
        <li>Cancellations and refunds are subject to our Cancellation Policy.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-4 text-gray-600">2. Service Usage</h2>
      <ul className="list-disc list-inside mb-4 text-gray-600">
        <li>Our taxi and travel services are available in multiple cities across India.</li>
        <li>Customers must provide accurate information when booking a ride or tour package.</li>
        <li>The Best Cab reserves the right to refuse service if inappropriate behavior is observed.</li>
        <li>Any damage caused to our vehicles or services by the customer will be chargeable.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-4 text-gray-600">3. Pricing and Charges</h2>
      <ul className="list-disc list-inside mb-4 text-gray-600">
        <li>Prices displayed on our website are subject to change.</li>
        <li>Additional charges may apply for extra kilometers, waiting time, and night travel.</li>
        <li>Toll taxes, parking fees, and state entry taxes are not included unless mentioned.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-4 text-gray-600">4. Responsibilities of Customers</h2>
      <ul className="list-disc list-inside mb-4 text-gray-600">
        <li>Customers must carry valid identification during their ride.</li>
        <li>Special requests (such as child seats) should be informed at the time of booking.</li>
        <li>Punctuality is required to avoid additional waiting charges.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-4 text-gray-600 ">5. Cancellation and Refund Policy</h2>
      <ul className="list-disc list-inside mb-4 text-gray-600 ">
        <li>Free cancellations are allowed within 24 hours for local rides.</li>
        <li>Outstation & Tour Packages cancellations within 48 hours may incur fees.</li>
        <li>Refunds will be processed within 7-10 working days after approval.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-4 text-gray-600">6. Liability Disclaimer</h2>
      <ul className="list-disc list-inside mb-4 text-gray-600">
        <li>We are not responsible for delays due to traffic, weather, or unforeseen circumstances.</li>
        <li>The Best Cab is not liable for personal belongings left in the vehicle.</li>
        <li>In case of a breakdown, we will arrange an alternative vehicle.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-4 text-gray-600">7. Privacy and Data Protection</h2>
      <p className="mb-4 text-gray-600">Customer data is collected and used as per our Privacy Policy. We do not sell or share personal data with unauthorized third parties.</p>

      <h2 className="text-xl font-semibold mt-4 text-gray-600">8. Third-Party Services</h2>
      <p className="mb-4 text-gray-600">Our website may contain links to third-party websites or services. We are not responsible for their terms, policies, or content.</p>

      <h2 className="text-xl font-semibold mt-4 text-gray-600">9. Modification of Terms</h2>
      <p className="mb-4 text-gray-600">The Best Cab reserves the right to update or modify these terms. Customers will be notified of significant changes.</p>

      <h2 className="text-xl font-semibold mt- text-gray-6004 text-gray-600">10. Contact Us</h2>
      <p className="mb-4 text-gray-600">For inquiries regarding these Terms and Conditions, please contact us:</p>
      <p className="mb-4 text-gray-600">📞 +91 92568 10874</p>
      <p className="mb-4 text-gray-600">📧 info@thebestcab.in</p>

      <p className="mt-4 font-semibold text-gray-600">By using our services, you acknowledge and agree to these Terms and Conditions. Thank you for choosing The Best Cab by Bharat Tours & Travels!</p>
    </div>
  );
};

export default Terms;